import { useLoadingDots } from '../../hooks/useLoadingDots';

/**
 * Animated "…" suffix for loading copy: `<H3>Generating image<LoadingDots /></H3>`.
 * The dots live in a fixed-width inline block so the sentence before them stays
 * put while they cycle.
 */
export const LoadingDots = ({
  active = true,
  intervalMs = 300,
  width = '25px',
}: {
  active?: boolean;
  intervalMs?: number;
  width?: string;
}) => {
  const dots = useLoadingDots(active, intervalMs);

  return (
    <span style={{ width, display: 'inline-block', textAlign: 'left' }}>
      {dots}
    </span>
  );
};
